import { doc, DocumentData, DocumentSnapshot } from 'firebase/firestore';
import { doc as fsDoc } from 'rxfire/firestore';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IUser } from '../../types';
import { authenticatedUserProvider } from '../userProvider';

interface IMetricSettingsDatabase {
  [testTypeId: string]: { [metricKey: string]: boolean };
  // @ts-ignore
  imperial?: boolean;
}

export interface IMetricSettings {
  imperial: boolean;
  metrics: {
    [testTypeId: string]: { [metricKey: string]: boolean };
  };
}

/**
 * @description hot observable of the users metric settings `/userProfiles/${user.id}/settings/metrics`
 */
export const metricSettings = new BehaviorSubject<IMetricSettings>(null);

/**
 * @description start observing metric settings
 */
authenticatedUserProvider()
  .pipe(
    switchMap((user: IUser): Observable<IMetricSettings> => {
      return fsDoc(
        doc(user.services.firestore, `userProfiles/${user.id}/settings/metrics`)
      ).pipe(
        map(
          (snap: DocumentSnapshot<DocumentData>): IMetricSettingsDatabase =>
            snap.exists ? (snap.data() as IMetricSettingsDatabase) : {}
        ),
        map((metrics: IMetricSettingsDatabase): IMetricSettings => {
          const imperial = metrics?.imperial ?? false;
          delete metrics?.imperial;
          return {
            metrics: metrics ?? {},
            imperial,
          };
        })
      );
    })
  )
  .subscribe(metricSettings);
